import { render, staticRenderFns } from "./ClassroomTypeSlidebar.vue?vue&type=template&id=35b3786a"
import script from "./ClassroomTypeSlidebar.vue?vue&type=script&lang=js"
export * from "./ClassroomTypeSlidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports